import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index-analytics',
  templateUrl: './index-analytics.component.html',
  styleUrls: ['./index-analytics.component.css']
})
export class IndexAnalyticsComponent implements OnInit {
  dataList = [
    ["fa-book","Registrations","/analytics/registrations"],
    ["fa-anchor","Enrolments","/analytics/enrollments"],
    ["fa-euro","Payments","/analytics/payments"],
    ["fa-empire","Quiz","/analytics/quiz"]
  ]
  constructor() { }

  ngOnInit(): void {

  }

}
